import React, { Component } from "react"
import I18n from "../utils/i18n.js"
import ReactDOM from "react-dom"

import createReactClass from 'create-react-class'

export default createReactClass({
  getDefaultProps() {
    return {
      options: {},
      form: ''
    };
  },

  formContent() {
    return {__html: this.props.friend_form};
  },

  render() {
    return <div id='send_to_a_friend_form' style={{ display: this.props.display_form ? 'block' : 'none' }}>
      <div dangerouslySetInnerHTML={this.formContent()} />
    </div>;
  }
});
